import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const update = createAction(ACTION.UPDATE.REQUEST);
export const resetError = createAction(ACTION.RESET_ERROR);
export const clearState = createAction(ACTION.CLEAR_STATE);
